class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    new IntersectionObserver(
      this.handleIntersection.bind(this)
    ).observe(this);
  }


  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {

        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(
            html,
            '.shopify-section'
          );

        document.dispatchEvent(
          new CustomEvent('cartdrawer:opened')
        );

      })
      .catch(e => {
        console.error(e);
      });
  }


  open() {

    /*
     * Always get the current drawer rather than relying
     * permanently on the reference from connectedCallback().
     */
    this.drawer = document.querySelector('cart-drawer');

    if (!this.drawer) {
      return;
    }

    /*
     * IMPORTANT:
     *
     * Do NOT return simply because <details> already
     * has the open attribute.
     *
     * The drawer can remain internally marked as open
     * after its previous appearance.
     *
     * We deliberately call openMenuDrawer() on every
     * successful Add to Cart.
     */
    if (typeof this.drawer.openMenuDrawer === 'function') {
      this.drawer.openMenuDrawer();
    }
  }


  renderContents(parsedState) {

    this.productId = parsedState.id;


    /*
     * Replace all cart sections with Shopify's
     * freshly returned versions.
     */
    this.getSectionsToRender().forEach((section) => {

      const sectionElement =
        document.getElementById(section.id);

      if (
        sectionElement &&
        parsedState.sections &&
        parsedState.sections[section.id]
      ) {

        sectionElement.innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );

      }

    });


    /*
     * Wait until the newly-rendered mini-cart DOM has
     * actually been painted before opening the drawer.
     */
    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        this.open();


        /*
         * Your theme fires this event when the mini-cart
         * first loads, so also fire it after every
         * subsequent cart render.
         */
        document.dispatchEvent(
          new CustomEvent('cartdrawer:opened')
        );

      });

    });
  }


  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {

    const parsedHTML =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const selectedElement =
      parsedHTML.querySelector(selector);


    if (!selectedElement) {
      return '';
    }


    return selectedElement.innerHTML;
  }


  setActiveElement(element) {
    this.activeElement = element;
  }
}


if (!customElements.get('mini-cart')) {
  customElements.define(
    'mini-cart',
    MiniCart
  );
}